const WRAPPED_SYMBOL = Symbol('versionWrapped');

/**
 * Replaces window.fetch with a wrapper that:
 * 1. Injects X-Client-Version on every request
 * 2. Calls onOutdated() when the server returns 426 (client too old)
 *
 * Safe to call multiple times — only wraps once.
 */
export function setupVersionedFetch(version: string, onOutdated: () => void): void {
  // Guard: don't double-wrap
  if ((window.fetch as unknown as Record<symbol, boolean>)[WRAPPED_SYMBOL]) return;

  const originalFetch = window.fetch.bind(window);
  const wrapped = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const headers = new Headers(
      init?.headers ?? (input instanceof Request ? input.headers : undefined),
    );
    headers.set('X-Client-Version', version);
    const response = await originalFetch(input, { ...init, headers });
    if (response.status === 426) {
      onOutdated();
    }
    return response;
  };
  (wrapped as unknown as Record<symbol, boolean>)[WRAPPED_SYMBOL] = true;
  window.fetch = wrapped;
}
